const USER_STORAGE = '@projectManage:user'
const AUTH_TOKEN_STORAGE = '@projectManage:token'
const TENANT_NAME_STORAGE = '@projectManage:tenant'

export { USER_STORAGE, AUTH_TOKEN_STORAGE, TENANT_NAME_STORAGE }
